import { useState } from 'react';

interface FilterBarProps {
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  categories: { id: string; label: string; icon: string }[];
}

export default function FilterBar({
  selectedCategory,
  onCategoryChange,
  searchQuery,
  onSearchChange,
  categories,
}: FilterBarProps) {
  return (
    <div id="categories" className="w-full px-4 md:px-6 py-6 md:py-8 scroll-mt-20">
      <div className="max-w-6xl mx-auto flex flex-col gap-5">
        <div className="relative w-full max-w-lg mx-auto">
          <span className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center pointer-events-none">
            <i className="ri-search-line text-foreground-400 text-sm"></i>
          </span>
          <input
            type="text"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Müşteri adı veya işlem ara..."
            className="w-full pl-10 pr-4 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all duration-200"
            aria-label="Yorumlarda ara"
          />
          {searchQuery && (
            <button
              onClick={() => onSearchChange('')}
              className="absolute right-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400 hover:text-foreground-600 cursor-pointer"
              aria-label="Aramayı temizle"
            >
              <i className="ri-close-circle-fill text-sm"></i>
            </button>
          )}
        </div>

        <div className="flex items-center justify-center flex-wrap gap-2">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                selectedCategory === cat.id
                  ? 'bg-primary-500 text-background-50 shadow-sm'
                  : 'bg-background-50 text-foreground-600 border border-background-300 hover:border-primary-300 hover:text-primary-600'
              }`}
              aria-pressed={selectedCategory === cat.id}
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`${cat.icon} text-sm`}></i>
              </span>
              {cat.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}